import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import StudentAssignmentForm from '../components/assignment/StudentAssignmentForm';
import Error from '../components/ui/Error';
import Loader from '../components/ui/Loader';
import Navbar from '../components/ui/Navbar'
import RelatedVideo from '../components/video/RelatedVideo';
import { useGetAssignmentMarksQuery } from '../features/assignmentMarks/assignmentMarksApi';
import { useGetAssignmentsQuery } from '../features/assignments/assignmentsApi';
import { useGetQuizzMarksQuery } from '../features/quizzMarks/quizzMarksApi';
import { useGetVideosQuery } from '../features/videos/videosApi'
import useAuth from '../hooks/useAuth';

function CoursePlayer() {
	//Variables
	const { data: videos, isError, isLoading } = useGetVideosQuery();
	const { data: marks } = useGetAssignmentMarksQuery();
	const { data: assignments } = useGetAssignmentsQuery();
	const { data: quizzMarks } = useGetQuizzMarksQuery();
	const { id: student_id } = useAuth();

	//States
	const [isAssignmentModalOpen, setIsAssignmentModalOpen] = useState(false);
	const [isAssignmentButtonEnable, setIsAssignmentModalEnable] = useState(true);
	const [isQuizButtonDisable, setIsQuizButtonDisable] = useState(false);
	const [assignment, setAssignment] = useState(null);
	const [mainVideo, setMainVideo] = useState([]);
	const [relatedVideos, setRelatedVideos] = useState([]);


	//Hooks
	useEffect(() => {
		const videoId = mainVideo.id;
		const studentId = student_id;
		const assignment = assignments?.find(a => a.video_id === videoId);

		if (!assignment) {
			setAssignment(null);
			return;
		} else {
			setAssignment(assignment);
		}

		const assignmentId = assignment.id;
		const mark = marks?.find(m => m.student_id === studentId && m.assignment_id === assignmentId);
		if (!mark) {
			setIsAssignmentModalEnable(true);
			return;
		}
		if (mark?.id) {
			setIsAssignmentModalEnable(false);
		}

	}, [marks, student_id, mainVideo, assignments])

	useEffect(() => {
		if (videos?.length > 0) {
			setMainVideo(videos[0]);
		}
	}, [videos])

	useEffect(() => {
		if (videos?.length > 0) {
			const relatedVideos = videos.filter(video => video.id !== mainVideo.id);
			setRelatedVideos(relatedVideos);
		}
	}, [mainVideo, videos])

	useEffect(() => {
		const isQuizButtonDisable = quizzMarks?.some((quizMark) => quizMark.student_id === student_id && quizMark.video_id === mainVideo.id);
		setIsQuizButtonDisable(isQuizButtonDisable);
	}, [quizzMarks, mainVideo.id, student_id])


	//Functions
	const toggleAssignmentModal = () => {
		setIsAssignmentModalOpen(!isAssignmentModalOpen);
	}

	//Decide what to render
	let content = null;

	if (isLoading) {
		content = <Loader />
	}
	if (!isLoading && isError) {
		content = <Error message="There was an error occured!" />
	}
	if (!isLoading && !isError && videos.length === 0) {
		content = <div className='text-center'>No Videos Found</div>
	}

	if (!isLoading && !isError && videos.length > 0) {
		content = (
			<div className="grid grid-cols-3 gap-2 lg:gap-8">
				<div className="col-span-full w-full space-y-8 lg:col-span-2">
					<iframe width="100%" className="aspect-video"  src={mainVideo?.url + "?autoplay=1"}
						title={mainVideo?.title}
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen></iframe>
					<div>
						<h1 className="text-lg font-semibold tracking-tight text-slate-100">
							{mainVideo?.title}
						</h1>
						<h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
							{`Uploaded on ${moment(mainVideo?.createdAt).format('D MMMM YYYY')}`}</h2>
						<div className="flex gap-4">
							{assignment &&
								<button
									onClick={toggleAssignmentModal}
									disabled={!isAssignmentButtonEnable}
									className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
									এসাইনমেন্ট
								</button>
							}
							<Link
								to={"/student-quizz"}
								state={{ id: mainVideo.id, title: mainVideo.title }}>
								<button
									disabled={isQuizButtonDisable}
									className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
								>
									কুইজে অংশগ্রহণ করুন
								</button>
							</Link>

						</div>
						<p className="mt-4 text-sm text-slate-400 leading-6">
							{mainVideo?.description}
						</p>
					</div>
				</div>
				<div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
					{relatedVideos?.length > 0 && (
						relatedVideos.map((relatedVideo) => (
							<RelatedVideo key={relatedVideo.id} relatedVideo={relatedVideo} handleSetVideo={setMainVideo} />
						))
					)}
				</div>
			</div >
		);
	}


	return (
		<>
			<Helmet>
				<title>Course Player</title>
			</Helmet>
			<Navbar />
			<section className="py-6 bg-primary">
				<div className="mx-auto max-w-7xl px-5 lg:px-0">
					{content}
				</div>
				{isAssignmentModalOpen && <StudentAssignmentForm isModalOpen={isAssignmentModalOpen} toggleModal={toggleAssignmentModal} mainVideo={mainVideo} assignment={assignment} />}
			</section>

		</>
	)
}

export default CoursePlayer
